import * as d3 from 'd3';
import * as turf from '@turf/turf';
import Vue from 'vue';

class Vervoerskaart {

	setSpecs(width) {
		this.iso = 0.56;

		const NLratio = 1.2;
		this.width = width;
		this.height = this.width * NLratio;
		this.scale = (this.width * 9000) / 650;

		this.projection = d3.geoMercator()
			.center([5.29, 52.18]) //midden van NL
			.scale(this.scale)
			.translate([this.width / 2, (this.height / 2)]);

		this.path = d3.geoPath()
			.projection(this.projection);

		this.zoomed = false;
	}

	container(ref) {
		this.container = d3.select(ref);
		this.setSpecs(this.container.node().getBoundingClientRect().width);
		
		return this;
	}

	data(data) {
		this.kaart = data;

		this.kaart.gemeenten.forEach(function(feature) {
			feature.geometry = turf.rewind(feature.geometry, {reverse:true});
		})

		// console.log("kaartdata", this.kaart);

		return this;
	}

	legenda(legenda) {
		this.kleuren = legenda;

		return this;
	}

	catSelected(cat) {
		this.catSelected = cat;

		return this;
	}

	callBacks(callBacks) {
		this.loadGemeente = callBacks["loadGemeente"];
		this.buurtClicked = callBacks["buurtClicked"];
		this.zoomOut = callBacks["zoomOut"];

		return this;
	}

	render() {
		this.graphic = this.container.append("svg")
			.attr("width", this.width)
			.attr("height", this.height)
			.attr("class", "knd-kaart-svg")
			.style("background-color", "#F8F5F2");

		this.gemeenten = this.graphic.selectAll(".gemeente")
			.data(this.kaart.gemeenten)
			.enter()
			.append("g")
				.attr("id", (d) => "gemeente_" + d.properties["GM_CODE"]);

		this.gemeentepaths = this.gemeenten.append("path")
			.attr("d", this.path)
			.attr("class", "gemeente")
			.style("fill", (d) => {
				return this.fillColor(d);
			})
			.style("stroke", "#fff")
			.on("click", (evt, d) => {
				if (this.zoomed) {
					this.zoomToNL();
				}
				else {
					this.gemeenteSelected(d.properties["GM_CODE"]);
				}
			})
			.on("mousemove", (evt, d) => {
				if (this.zoomed) {
					this.hideTooltip();
				}
				else {
					this.moveTooltip(evt, d)
				}
			});

		//naast de kaart klikken
		this.graphic
			.on("click", (evt) => {
				if(evt.target.tagName === "svg") {
					this.zoomToNL();
				}
			})
			.on("mousemove", (evt) => {
				if(evt.target.tagName === "svg") {
					this.hideTooltip();
				}
			});

		d3.selectAll(".knd-kaart-zoomuit")
			.on("click", () => {
				this.zoomToNL();
			});

		return this;
	}

	gemeenteSelected(gemeente) {
		this.loadGemeente(gemeente);
	}

	restyleKaart(cat) {
		// console.log("restyle de kaart");
		this.catSelected = cat;

		this.styleGemeenten(this.zoomed);

		if (this.buurtPaths) {
			this.buurtPaths.style("fill", (d) => {
				return this.fillColor(d);
			});
		}
	}

	moveTooltip(evt, d) {
		d3.select("#knd-tooltip")
			.classed("hide", false);

		let [x, y] = d3.pointer(evt);

		if (x > this.width / 2) {
			x = x - 200;
		}

		if (d.properties["BU_NAAM"]) {
			d3.select("#knd-tooltip")
				.style("left", x + "px")
				.style("top", y + "px")
				.html("Buurt: <b>" + d.properties["BU_NAAM"] + "</b>")
		}
		else {
			d3.select("#knd-tooltip")
				.style("left", x + "px")
				.style("top", y + "px")
				.html("Gemeente: <b>" + d.properties["GM_NAAM"] + "</b>")
		}
	}

	hideTooltip() {
		d3.select("#knd-tooltip")
			.classed("hide", true);
	}

	styleGemeenten(zoomed) {
		this.gemeentepaths
			.style("stroke-width", "1px")
			.style("stroke", "#F8F5F2")
			.style("fill", (d) => {
				return this.fillColor(d);
			});

		if (zoomed) {
			this.gemeentepaths
				.style("fill", "#F8F5F2");
		}
	}

	fillColor(d) {
		const value = Math.round(d.properties[this.catSelected["key"]]);
		const kleurFound = this.kleuren.find((kleur) => {
			return value == kleur.value;
		});

		let kleur;
		if (kleurFound) {
			kleur = kleurFound.kleur;
		}
		else {
			kleur = "#fff"	
		}
		return kleur;
	}

	zoomToBounds(gemeente) {
		const gemeenteBounds = this.kaart.gemeenten.find((item) => {
			return item.properties["GM_CODE"] === gemeente["GM_CODE"];
		});

		// console.log("zoom to bounds", gemeente);
		var bounds = this.path.bounds(gemeenteBounds);

		// calculate the width and height of the bounds
		var width = bounds[1][0] - bounds[0][0];
		var height = bounds[1][1] - bounds[0][1];

		// calculate the center of the bounds
		var centerX = (bounds[0][0] + bounds[1][0]) / 2;
		var centerY = (bounds[0][1] + bounds[1][1]) / 2;

		let ratio = null
		if (width > height) {
			ratio = this.width / width;
		}
		else {
			ratio = this.height / height;
		}
		const margin = 5000;
		const scaleNow = (this.scale * ratio) - margin;
		// console.log("scale now", scaleNow);

		const projectionNow = d3.geoMercator()
			.center(this.projection.invert([centerX, centerY]))
			.scale(scaleNow)
			.translate([this.width / 2, (this.height / 2)]);

		const pathNow = d3.geoPath()
			.projection(projectionNow);

		this.gemeentepaths
			.transition()
			.duration(500)
			.ease(d3.easeSinInOut)
			.attr("d", pathNow);

		this.zoomed = true;
		
		window.setTimeout(() => {
			this.styleGemeenten(true);
		}, 500);

		this.renderBuurten(gemeente, pathNow);
	}

	zoomToNL() {
		this.projection = d3.geoMercator()
			.center([5.29, 52.18]) //midden van NL
			.scale(this.scale)
			.translate([this.width / 2, (this.height / 2)]);

		this.path = d3.geoPath()
			.projection(this.projection);

		this.gemeentepaths
			.transition()
			.duration(500)
			.ease(d3.easeSinInOut)
			.attr("d", this.path);

		this.graphic.selectAll(".buurten").remove();

		this.zoomed = false;
		this.styleGemeenten(false);
		this.zoomOut();
	}

	deepCopyObject(obj) {
		const copiedObject = {};

		for (const key in obj) {
			if (Array.isArray(obj[key])) {
				copiedObject[key] = this.deepCopyArray(obj[key]); // Recursively copy nested arrays
			} else if (typeof obj[key] === 'object') {
				copiedObject[key] = this.deepCopyObject(obj[key]); // Recursively copy nested objects
			} else {
				copiedObject[key] = obj[key];
			}
		}

		return copiedObject;
	}

	deepCopyArray(arr) {
		const copiedArray = [];

		for (let i = 0; i < arr.length; i++) {
			if (Array.isArray(arr[i])) {
				copiedArray[i] = this.deepCopyArray(arr[i]); // Recursively copy nested arrays
			} else if (typeof arr[i] === 'object') {
				copiedArray[i] = this.deepCopyObject(arr[i]); // Recursively copy nested objects
			} else {
				copiedArray[i] = arr[i];
			}
		}

		return copiedArray;
	}

	renderBuurten(gemeente, pathNow) {
		this.graphic.selectAll(".buurten").remove();
		const buurtData = this.deepCopyArray(gemeente.buurten); //deep copy, anders triggert hij de watcher

		buurtData.forEach(function(feature) {
			feature.geometry = turf.rewind(feature.geometry, {reverse:true});
		})

		const buurtGroup = this.graphic.selectAll("#gemeente_" + gemeente["GM_CODE"])
			.append("g")
				.attr("class", "buurten");

		const buurten = buurtGroup.selectAll(".buurt")
			.data(buurtData.filter((d) => {
				return d.properties["BU_NAAM"] !== ""; //geen water
			}))
			.enter()
			.append("g")
				.attr("id", (d) => "buurt" + d.properties["BU_CODE"]);

		window.setTimeout(() => {
			this.buurtPaths = buurten.append("path")
				.attr("d", pathNow)
				.attr("class", "buurt")
				.style("fill", (d) => {
					return this.fillColor(d);
				})
				.style("stroke", (d) => {
					return d.properties["Verschil_perc"] ? '#fff' : '#F8F5F2'; // If no range matches, use a default color
				})
				.on("click", (evt, d) => {
					// console.log(d.properties);
					this.buurtClicked(d);
				})
				.on("mousemove", (evt, d) => {
					this.moveTooltip(evt, d)
				});
			}, 500);	
	}
}

export default Vervoerskaart;